import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUnity } from '@fortawesome/free-brands-svg-icons';
import { faServer, faDatabase } from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "Unity",
    "C#",
    "VR / AR / XR",
    "URP / HDRP / SRP",
    "Shader Graph",
    "VFX Graph",
    "Blender"
];

const labelsSecond = [
    "ASP.NET Core",
    "C#",
    "REST API",
    "Entity Framework",
    "Authentication",
    "Security"
];

const labelsThird = [
    "MySQL",
    "PostgreSQL",
    "MS SQL",
    "T-SQL",
    "Schema Modeling",
    "Query Optimization"
];

function Expertise() {
    return (
        <div className="container" id="expertise">
            <div className="skills-container">
                <h1>Expertise</h1>
                <p style={{ textAlign: "justify", margin: "0 auto 40px auto", fontSize: "1.5rem" }}>
                    My greatest satisfaction comes from solving complex technical challenges, improving system performance, and deploying solutions that genuinely elevate product quality. I treat programming not just as a profession, but as a field I constantly explore and grow in.
                </p>
                <div className="skills-grid">
                    <div className="skill">
                        <FontAwesomeIcon icon={faUnity} size="3x" />
                        <h3>Unity Development</h3>
                        <p style={{ textAlign: "justify" }}>
                            Experienced Unity Developer specializing in 3D, VR, and XR projects. I cover the full Unity ecosystem—from architecture and performance optimization to implementing mechanics, UI, and backend integrations. With a strong engineering approach to code quality, I often take on the role of a "one-man army," handling both programming and technical aspects of production across desktop, mobile, and immersive immersive devices.
                        </p>
                        <p>
                            I have a deep interest in networking and co-authored a multiplayer solution published in an <a href="https://ieeexplore.ieee.org/document/10536472" target="_blank" rel="noreferrer" style={{ color: '#007BFF', textDecoration: 'underline' }}>IEEE publication</a>. I actively work with rendering pipelines (URP, HDRP, SRP), Shader Graph, and particle systems. I also create educational content, such as tutorials on <a href="https://youtu.be/3264A7bUkDs?si=7vcQ-dXOKIzdaYjh" target="_blank" rel="noreferrer" style={{ color: '#007BFF', textDecoration: 'underline' }}>maze generation in Unity</a> and <a href="https://www.youtube.com/@programowanie9760" target="_blank" rel="noreferrer" style={{ color: '#007BFF', textDecoration: 'underline' }}>design patterns</a>.
                        </p>
                        <div className="flex-chips">
                            <span className="chip-title">Tech stack:</span>
                            {labelsFirst.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>

                    <div className="skill">
                        <FontAwesomeIcon icon={faServer} size="3x" />
                        <h3>Backend / ASP.NET</h3>
                        <p style={{ textAlign: "justify" }}>
                            I design and implement lightweight backend services supporting real-time applications. I build reliable APIs and server logic using ASP.NET, ORMs, and object mappers, focusing on data validation, authentication, authorization, and standard security practices. These systems are deliberately kept in a simple, readable architecture to ensure long-term stability and easy scalability.
                        </p>
                        <div className="flex-chips">
                            <span className="chip-title">Tech stack:</span>
                            {labelsSecond.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>

                    <div className="skill">
                        <FontAwesomeIcon icon={faDatabase} size="3x" />
                        <h3>Databases & Architecture</h3>
                        <p style={{ textAlign: "justify" }}>
                            I design, deploy, and administrate relational databases, primarily working with MySQL, PostgreSQL, and MS SQL. My expertise encompasses schema modeling, query optimization, and maintaining data consistency. Within the .NET environment, I seamlessly integrate data layers with application logic using Entity Framework in a highly efficient and predictable manner.
                        </p>
                        <div className="flex-chips">
                            <span className="chip-title">Tech stack:</span>
                            {labelsThird.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Expertise;